export default function BackIcon({ className = "w-6 h-6" }) {
  return (
    <svg className={className} width="12" height="15" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 20.5L0 10.5L10 0.5L11.775 2.275L3.55 10.5L11.775 18.725L10 20.5Z" fill="currentColor" />
    </svg>
  );
}
